/**
 * @file コンポーネント：フル動画ページ機器広告スライダー DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledSlider,
    StyledSliderActionlist,
    StyledSliderActionlistButton,
    StyledSliderActionlistItem,
    StyledSliderArrow,
    StyledSliderArrowInactivePrev,
    StyledSliderArrowInactiveNext,
    StyledSliderArrowlist,
    StyledSliderArrowlistItemLeft,
    StyledSliderArrowlistItemRight,
    StyledSliderButton,
    StyledSliderButtonlist,
    StyledSliderButtonlistItem,
    StyledSliderContainer,
    StyledSliderContentlist,
    StyledSliderContentlistItem,
    StyledSliderDot,
    StyledSliderDotInactive,
    StyledSliderDotlist,
    StyledSliderDotlistItem,
    StyledSliderArrowPrev,
    StyledSliderArrowNext,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledSlider
            className={[
                props.sliderCover === true && "is-covered",
                props.isZoom === true && "is-zoom",
            ]}
        >
            {props.zoom && props.list.length > 0 && (
                // ズーム機能がtrueかつスライドが1枚以上ある場合
                <StyledSliderActionlist
                    className={props.isZoom === true && "is-zoom"}
                >
                    {props.isZoom === true ? (
                        // 拡大表示中
                        <>
                            <StyledSliderActionlistItem>
                                <StyledSliderActionlistButton
                                    onClick={() => props.fnZoomOutSlide()}
                                    disabled={
                                        props.magnifications[
                                            props.currentIndex
                                        ] === 50 && "disabled"
                                    }
                                >
                                    <i className="fas fa-minus"></i>
                                </StyledSliderActionlistButton>
                            </StyledSliderActionlistItem>
                            <StyledSliderActionlistItem>
                                <StyledSliderActionlistButton
                                    onClick={() => props.fnZoomInSlide()}
                                    disabled={
                                        props.magnifications[
                                            props.currentIndex
                                        ] === 200 && "disabled"
                                    }
                                >
                                    <i className="fas fa-plus"></i>
                                </StyledSliderActionlistButton>
                            </StyledSliderActionlistItem>
                            <StyledSliderActionlistItem>
                                <StyledSliderActionlistButton
                                    onClick={() =>
                                        props.setIsZoom(!props.isZoom)
                                    }
                                    title={localized["Label.ZoomOutContent"]}
                                >
                                    <i className="fas fa-times"></i>
                                </StyledSliderActionlistButton>
                            </StyledSliderActionlistItem>
                        </>
                    ) : (
                        // 通常表示中
                        <StyledSliderActionlistItem>
                            <StyledSliderActionlistButton
                                onClick={() => props.setIsZoom(!props.isZoom)}
                                title={localized["Label.ZoomInContent"]}
                            >
                                <i className="fas fa-search-plus"></i>
                            </StyledSliderActionlistButton>
                        </StyledSliderActionlistItem>
                    )}
                </StyledSliderActionlist>
            )}
            <StyledSliderContainer>
                <StyledSliderContentlist ref={props.refSliderContentlist}>
                    {props.list.map((item, index) => (
                        <StyledSliderContentlistItem
                            className={
                                index === props.currentIndex && "is-current"
                            }
                            key={"slide-" + index}
                            ref={
                                index === props.currentIndex
                                    ? props.refSliderContentlistItem
                                    : null
                            }
                        >
                            {item}
                        </StyledSliderContentlistItem>
                    ))}
                </StyledSliderContentlist>
                {props.arrows && props.list.length > 1 && (
                    <>
                        {props.currentIndex === 0 ? (
                            <StyledSliderArrowInactivePrev />
                        ) : (
                            <StyledSliderArrowPrev
                                onClick={() => props.setCurrentIndex(props.currentIndex - 1)}
                                title={localized["Label.Previous"]}
                            />
                        )}

                        {props.currentIndex === props.list.length - 1 ? (
                            <StyledSliderArrowInactiveNext />
                        ) : (
                            <StyledSliderArrowNext
                                onClick={() => props.setCurrentIndex(props.currentIndex + 1)}
                                title={localized["Label.Next"]}
                            />
                        )}
                    </>
                )}

            </StyledSliderContainer>
            {/* ボタンリスト */}
            {props.isZoom === true &&
                Array.isArray(props.buttonlist) === true &&
                props.buttonlist.length > 0 && (
                    <StyledSliderButtonlist>
                        {props.buttonlist.map((button, index) => (
                            <StyledSliderButtonlistItem key={"button-" + index}>
                                <StyledSliderButton
                                    data-button-type={button.buttonType}
                                    href={button.href ? button.href : "#"}
                                    onClick={button.onClick}
                                >
                                    {button.text}
                                </StyledSliderButton>
                            </StyledSliderButtonlistItem>
                        ))}
                    </StyledSliderButtonlist>
                )}
        </StyledSlider>
    );
};
